import { Link } from "react-router-dom";
import { ELF_EMERGENCY_GUIDES, getEmergencyGuidePath } from "@/data/elfEmergencyGuides";

export default function EmergencyGuideLinks() {
  return (
    <section aria-label="Quick elf help" className="mx-auto my-10 max-w-5xl">
      <div className="mb-5 flex flex-wrap items-baseline justify-between gap-3">
        <h2 className="text-2xl font-bold">An elf emergency? Start here.</h2>
        <Link to="/elf-help/" className="text-sm font-semibold text-elfGreen-ink underline underline-offset-4">All elf help guides</Link>
      </div>
      <ul className="grid gap-4 md:grid-cols-3">
        {ELF_EMERGENCY_GUIDES.map((guide) => (
          <li key={guide.slug}><Link to={getEmergencyGuidePath(guide)} className="block h-full rounded-xl border border-elfGreen/30 bg-white p-5 text-elfGreen-ink hover:bg-elfGreen-light/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-elfGreen-dark"><h3 className="font-semibold">{guide.title}</h3><p className="mt-2 text-sm leading-relaxed text-slate-600">{guide.description}</p></Link></li>
        ))}
      </ul>
    </section>
  );
}
